export interface Testimonial {
  initials: string
  name: string
  location: string
  text: string
  color: string
  pack?: string
}

export const initialTestimonials: Testimonial[] = [
  {
    initials: 'MG',
    name: 'María G.',
    location:
      '🧑‍🏫 Docente de Criminalística, Instituto de Formación Policial — Buenos Aires',
    text: 'En una tarde tenía más material sobre criminalística contextualizado en Argentina que en toda mi carrera docente. Ahora mis alumnos me preguntan sobre el Caso Rojas de 1892, el BNDG, el EAAF y cómo procesa la PFA una escena del hecho en 2026, y tengo respuesta fundamentada para todo.',
    color: 'bg-blue-700',
  },
  {
    initials: 'RT',
    name: 'Rodrigo T.',
    location: '🧑‍🏫 Docente de Ciencias Forenses, Terciario Policial — Santa Cruz',
    text: 'Mis alumnos por primera vez entendieron la diferencia entre indicio, evidencia y prueba, y analizaron un caso real de impugnación pericial con argumentos técnicos reales. El nivel de participación se multiplicó.',
    color: 'bg-blue-800',
  },
  {
    initials: 'SP',
    name: 'Sandra P.',
    location: '🧑‍🏫 Profesora de Criminalística y Pericias — Córdoba',
    text: 'Las simulaciones de escena del hecho con los checklists del MEGAPACK son exactamente lo que mis alumnos necesitaban: protocolo real con contexto argentino. Cambió todo.',
    color: 'bg-blue-600',
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    initials: 'FM',
    name: 'Federico M.',
    location: '🏙️ Buenos Aires',
    text: 'Con el MEGAPACK, en una tarde tenía el argumento pedagógico completo para explicar por qué Juan Vucetich, nacido en lo que hoy es Croacia y radicado en Argentina, construyó el primer sistema dactilar funcional del mundo. Y por qué el primer asesino condenado por una huella dactilar en la historia de la humanidad fue juzgado en Necochea, Provincia de Buenos Aires, en 1892. Mis alumnos empezaron a ver la Criminalística como algo argentino. Porque lo es.',
    color: 'bg-blue-700',
    pack: 'Megapack Criminalística',
  },
  {
    initials: 'RV',
    name: 'Rosa V.',
    location: '🏙️ Neuquén',
    text: 'Cuando explicás que el Art. 275 del Código Penal argentino penaliza con prisión al perito que miente en su dictamen, y que esa responsabilidad es la que hace que la ciencia pueda hablar en un tribunal con credibilidad, empieza un debate sobre ética, verdad y justicia que ninguna otra materia genera.',
    color: 'bg-blue-800',
    pack: 'Megapack Criminalística',
  },
  {
    initials: 'GN',
    name: 'Gabriela N.',
    location: '🏙️ Santa Cruz',
    text: 'Cuando mis alumnos descubren que Argentina tuvo el primer banco de datos genéticos del mundo creado con fines de derechos humanos —para identificar a los hijos de los desaparecidos de la última dictadura— y que ese banco sigue funcionando y restituye identidades hasta hoy, empieza una conversación sobre ciencia, historia y justicia que ningún libro de texto puede provocar.',
    color: 'bg-blue-600',
    pack: 'Megapack Criminalística',
  },
  {
    initials: 'AS',
    name: 'Alejandro S.',
    location: '🏙️ Río Negro',
    text: 'Cerré la planificación anual en dos horas. Antes me llevaba semanas. Ahora tengo todo el año organizado con los protocolos 2026, el marco legal argentino actualizado y los casos del Bono 2 integrados en cada unidad.',
    color: 'bg-blue-900',
    pack: 'Megapack Criminalística',
  },
  {
    initials: 'SM',
    name: 'Sofía M.',
    location: '🏙️ Mendoza',
    text: 'Cuando les digo a mis alumnos que el perito que procesa la escena del hecho tiene en sus manos el destino de un culpable y de un inocente al mismo tiempo, y que la diferencia entre uno y otro puede ser una huella dactilar mal levantada o un sobre mal embalado, les estoy enseñando lo que significa la responsabilidad profesional en el mundo real.',
    color: 'bg-blue-700',
    pack: 'Megapack + Upsell Premium',
  },
]
